const getDefaultState = () => {
  return {
    shoppingMallType: 'CAFE24',
    useCommerce: false,
    useCafe24: false,
    isUseAboutTalk: false,
    aboutTalkHeader: {},
    useSmartStore: false,
    prodImgList: {},
    useMakeshop: false,
    isLoading: false,
    customerInfo: null,
    reservationInfo: null,
    reservationPagination: {
      page: 0,
      size: 5,
      totalElement: 0,
      totalPage: 0
    },
    isApiCalling: false
  };
};
const state = getDefaultState();

const getters = {
  shoppingMallType: (state) => {
    return state.shoppingMallType;
  },
  useCommerce: (state) => {
    return state.useCommerce;
  },
  useCafe24: (state) => {
    return state.useCafe24;
  },
  isUseAboutTalk(state) {
    return state.isUseAboutTalk;
  },
  aboutTalkHeader(state) {
    return state.aboutTalkHeader;
  },
  useSmartStore: (state) => {
    return state.useSmartStore;
  },
  prodImgList: (state) => {
    return state.prodImgList;
  },
  useMakeshop: (state) => {
    return state.useMakeshop;
  },
  getIsLoading: (state) => {
    return state.isLoading;
  },
  getCustomerInfo: (state) => {
    return state.customerInfo;
  },
  getReservationInfo: (state) => {
    return state.reservationInfo;
  },
  getReservationPagination: (state) => {
    return state.reservationPagination;
  },
  getIsApiCalling: (state) => {
    return state.isApiCalling;
  }
};

const actions = {};

const mutations = {
  setShoppingMallType(state, shoppingMallType) {
    state.shoppingMallType = shoppingMallType;
  },
  setUseCommerce(state, useCommerce) {
    state.useCommerce = useCommerce;
  },
  setUseCafe24(state, useCafe24) {
    state.useCafe24 = useCafe24;
  },
  setIsUseAboutTalk(state, data) {
    state.isUseAboutTalk = data.isUse;
    if (data.isUse) {
      state.aboutTalkHeader = {
        'dmc-client-id': data.dmcClientId,
        'dmc-client-secret': data.dmcClientSecret,
        'Content-Type': 'application/json'
      };
    }
  },
  setUseSmartStore(state, useSmartStore) {
    state.useSmartStore = useSmartStore;
  },
  setProdImgList: (state, prodImgList) => {
    state.prodImgList = prodImgList;
  },
  setUseMakeshop(state, useMakeshop) {
    state.useMakeshop = useMakeshop;
  },
  setIsLoading(state, payload) {
    state.isLoading = payload;
  },
  setCustomerInfo(state, payload) {
    state.customerInfo = payload;
  },
  setReservationInfo(state, payload) {
    state.reservationInfo = payload;
  },
  setReservationPagination(state, payload) {
    if (payload.length === 5) {
      state.reservationPagination = payload;
    } else {
      state.reservationPagination.page = payload.page || state.reservationPagination.page;
      state.reservationPagination.size = payload.size || state.reservationPagination.size;
      state.reservationPagination.totalElement = payload.totalElement || state.reservationPagination.totalElement;
      state.reservationPagination.totalPage = payload.totalPage || state.reservationPagination.totalPage;
    }
  },
  setReservationPaginationInit(state) {
    state.reservationPagination = {
      page: 0,
      size: state.reservationPagination.size,
      totalElement: 0,
      totalPage: 0
    };
  },
  setIsApiCalling(state, payload) {
    state.isApiCalling = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/talkOperation/index.js